<template>
  <PageSection>
    <WithSidebar
      placement="left"
      collapse="top"
    >
      <template #sidebar>
        <ResponsiveUserPageSidebar :user="user" />
      </template>
      <template #default>
        <SectionBox>
          <BasicSection>
            <SubTabs
              v-if="tabs"
              :tabs="tabs"
              appearance="primary"
            />
            <UserFriendsList
              v-if="userFriends"
              v-model="userFriends"
              :user-id="user.id"
            />
            <UserPagePlaceholder
              v-else
              :placeholder="placeholder"
            />
          </BasicSection>
        </SectionBox>
      </template>
    </WithSidebar>
  </PageSection>
</template>

<script>
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import PageSection from 'src/components/sections/PageSection/PageSection.vue';
  import SubTabs from 'src/components/tabs/SubTabs/SubTabs.vue';
  import ResponsiveUserPageSidebar from 'src/components/users/ResponsiveUserPageSidebar/ResponsiveUserPageSidebar.vue';
  import UserFriendsList from 'src/components/users/UserFriendsList/UserFriendsList.vue';
  import UserPagePlaceholder from 'src/components/users/UserPagePlaceholder/UserPagePlaceholder.vue';
  import WithSidebar from 'src/components/WithSidebar/WithSidebar.vue';
  
  export default {
    name: 'UserFriendsPage',
    components: {
      ResponsiveUserPageSidebar,
      UserFriendsList,
      SubTabs,
      BasicSection,
      SectionBox,
      UserPagePlaceholder,
      WithSidebar,
      PageSection,
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      friends: Object,
      placeholder: Object,
      tabs: Array,
    },
    data() {
      return {
        userFriends: this.friends,
      };
    },
  };
</script>